var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0022 2.98125C14.9418 2.98125 15.2899 2.99414 16.446 3.04571C17.5204 3.09299 18.1006 3.27349 18.4874 3.42391C18.9988 3.62161 19.3684 3.86228 19.7509 4.24477C20.1377 4.63157 20.3741 4.99687 20.5718 5.5083C20.7222 5.8951 20.9027 6.47959 20.95 7.54972C21.0016 8.7101 21.0145 9.05822 21.0145 11.9936C21.0145 14.9332 21.0016 15.2813 20.95 16.4374C20.9027 17.5118 20.7222 18.092 20.5718 18.4788C20.3741 18.9902 20.1334 19.3598 19.7509 19.7423C19.3641 20.1291 18.9988 20.3655 18.4874 20.5632C18.1006 20.7136 17.5161 20.8941 16.446 20.9414C15.2856 20.993 14.9375 21.0059 12.0022 21.0059C9.06251 21.0059 8.7144 20.993 7.55831 20.9414C6.48388 20.8941 5.90369 20.7136 5.5169 20.5632C5.00547 20.3655 4.63587 20.1248 4.25337 19.7423C3.86658 19.3555 3.6302 18.9902 3.43251 18.4788C3.28209 18.092 3.10158 17.5075 3.05431 16.4374C3.00274 15.277 2.98984 14.9289 2.98984 11.9936C2.98984 9.05392 3.00274 8.7058 3.05431 7.54972C3.10158 6.47529 3.28209 5.8951 3.43251 5.5083C3.6302 4.99687 3.87087 4.62727 4.25337 4.24477C4.64016 3.85798 5.00547 3.62161 5.5169 3.42391C5.90369 3.27349 6.48818 3.09299 7.55831 3.04571C8.7144 2.99414 9.06251 2.98125 12.0022 2.98125ZM12.0022 1C9.01524 1 8.64134 1.01289 7.46806 1.06447C6.29908 1.11604 5.49541 1.30514 4.79918 1.57589C4.07287 1.85954 3.45829 2.23344 2.84802 2.84802C2.23344 3.45829 1.85954 4.07287 1.57589 4.79488C1.30514 5.49541 1.11604 6.29478 1.06447 7.46376C1.01289 8.64134 1 9.01524 1 12.0021C1 14.9891 1.01289 15.363 1.06447 16.5362C1.11604 17.7052 1.30514 18.5089 1.57589 19.2051C1.85954 19.9314 2.23344 20.546 2.84802 21.1563C3.45829 21.7666 4.07287 22.1448 4.79488 22.4241C5.49541 22.6949 6.29478 22.884 7.46376 22.9355C8.63704 22.9871 9.01094 23 11.9979 23C14.9848 23 15.3587 22.9871 16.5319 22.9355C17.7009 22.884 18.5046 22.6949 19.2008 22.4241C19.9228 22.1448 20.5374 21.7666 21.1477 21.1563C21.758 20.546 22.1362 19.9314 22.4155 19.2094C22.6863 18.5089 22.8754 17.7095 22.9269 16.5405C22.9785 15.3673 22.9914 14.9934 22.9914 12.0064C22.9914 9.01954 22.9785 8.64563 22.9269 7.47236C22.8754 6.30338 22.6863 5.49971 22.4155 4.80348C22.1448 4.07287 21.7709 3.45829 21.1563 2.84802C20.546 2.23774 19.9314 1.85954 19.2094 1.58019C18.5089 1.30944 17.7095 1.12034 16.5405 1.06876C15.363 1.01289 14.9891 1 12.0022 1Z",
    fill: "url(#paint0_linear_7585_44421)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0021 6.35065C8.88201 6.35065 6.35065 8.88201 6.35065 12.0021C6.35065 15.1223 8.88201 17.6536 12.0021 17.6536C15.1223 17.6536 17.6536 15.1223 17.6536 12.0021C17.6536 8.88201 15.1223 6.35065 12.0021 6.35065ZM12.0021 15.6681C9.97793 15.6681 8.3362 14.0264 8.3362 12.0021C8.3362 9.97793 9.97793 8.3362 12.0021 8.3362C14.0264 8.3362 15.6681 9.97793 15.6681 12.0021C15.6681 14.0264 14.0264 15.6681 12.0021 15.6681Z",
    fill: "url(#paint1_linear_7585_44421)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1965 6.12713C19.1965 6.85774 18.6034 7.44653 17.8771 7.44653C17.1465 7.44653 16.5577 6.85345 16.5577 6.12713C16.5577 5.39652 17.1508 4.80773 17.8771 4.80773C18.6034 4.80773 19.1965 5.40082 19.1965 6.12713Z",
    fill: "url(#paint2_linear_7585_44421)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7585_44421",
    x1: 5.67317,
    y1: 20.525,
    x2: 20.2484,
    y2: 5.40569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502762,
    stopColor: "#F71F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC11B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7585_44421",
    x1: 5.67317,
    y1: 20.525,
    x2: 20.2484,
    y2: 5.40569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502762,
    stopColor: "#F71F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC11B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7585_44421",
    x1: 5.67317,
    y1: 20.525,
    x2: 20.2484,
    y2: 5.40569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F88A20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502762,
    stopColor: "#F71F49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC11B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e279367d3e7e5c28ad66460363a9cd57.svg";
export { ForwardRef as ReactComponent };